<template>
  <div class="choice-om">
    <transition appear name="fade">
    <div class="container">

      <div class="entry">
        <h1 class="title">Overheidsorganisatie of museum?</h1>

        <div class="content">
          <p>De zorgvuldige omgang met cultuurgoederen vergt in de praktijk samenwerking tussen de eigenaar en de feitelijk beheerder ervan. Bent u een overheidsorganisatie die eigenaar is van de betreffende cultuurgoederen en zijn uw cultuurgoederen niet in beheer bij een museum? Of bent u een beheerder van collecties, bijvoorbeeld een museum? Dit verschil in rollen is van invloed op de te volgen procedure bij het vervreemden van een cultuurgoed.</p>
        </div>

        <div class="row">
          <ButtonWithImage
            class="col"
            route="/overheid"
          >
            <img
              slot="image"
              :src="require('@/assets/images/buttons/button-overheid.svg')"
              alt=""
              draggable="false"
              class="image"
            />
            <span>Start stappenplan overheid</span>
          </ButtonWithImage>

          <ButtonWithImage
            class="col"
            route="/museum"
          >
            <img
              slot="image"
              :src="require('@/assets/images/buttons/button-museum.svg')"
              alt=""
              draggable="false"
              class="image"
            />
            <span>Start stappenplan museum</span>
          </ButtonWithImage>
        </div>
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
import ButtonWithImage from '@/components/ButtonWithImage'

export default {
  name: 'ChoiceOM',
  components: { ButtonWithImage },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .choice-om {

  }
  .container {
    @extend %container;
    padding-top: 70px;
    padding-bottom: 70px;

    @media (max-width: 1381px) {
      padding-top: 46px;
      padding-bottom: 46px;
    }
  }
  .row {
    @extend %row;
    font-size: 0;
  }
  .col {
    width: 50%;
    display: inline-block;
  }
  .title {
    margin-top: 0;
    margin-bottom: 0.71em;
  }
  .entry {
    max-width: 766px;
  }
</style>



// WEBPACK FOOTER //
// src/domains/ChoiceOM.vue